import {toCurrency,showPercentage} from '@/shared/helpers'

export const TODAY_DATA =[
    {
        title: "Today's Awards",
        today: {
                value: 300,
                unit: "Points",
                award: 0,
                awardText:"Awards"
            },
        ytd: {
            value: 32600,
            amount: 815,
        },
        mtd: {
            value: 0,
            amount: 0,
        }
    },
    {
        title: "Today's Redemptions",
        today: {
                value: 300,
                unit: "Points",
                award: 0,
                awardText:"Awards"
            },
        ytd: {
            value: 6600,
            amount: 815,
        },
        mtd: {
            value: 0,
            amount: 0,
        }
    },
    {
        title: "Today's Active Participants",
        today: {
                value: 2558,
                unit: "Active",
                award: "",
                awardText:""
            },
        ytd: {
            value: 1582,
            
            
        },
        mtd: {
            value: 5874,
            
        }
    },
]

export const TOP_MERCHANTS = [
    "Bobrowski, Robert",
    "Bradley, Megha",
    "Conner, Rlck",
    "Bobrowski, Robert",
    "Bradley, Megha",
    "Conner, Rlck",
]

export const TOP_AWARDS = [
    {
        type: "Starbucks",
        value: 800
    },
    {
        type: "Starbucks",
        value: 1800
    },
    {
        type: "Starbucks",
        value: 24800
    },
    {
        type: "Starbucks",
        value: 250
    },
    {
        type: "Starbucks",
        value: 800
    },
    {
        type: "Starbucks",
        value: 1000
    }
]
const labels = ['Mar-05','Mar-06', 'Mar-07', 'Mar-08', 'Mar-09', 'Mar-10', 'Mar-11', 'Mar-12'];
export const CHART_DATA = [
    {
        labels,
        datasets: [
          {
            label: 'Dataset 1',
            data: labels.map(() => Math.random() * 60),
            borderColor: '#26CE83',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
          }
        ],
      },
      {
        labels,
        datasets: [
          {
            label: 'Dataset 2',
            data: labels.map(() => Math.random() * 60),
            borderColor: '#573BFF',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
          }
        ],
      }
]

export const EVENTS_COLUMNS = [
    {
        Header: "Name",
        accessor: "name",
    },
    {
        Header: "Event Type",
        accessor: "type",
    }
]

export const EVEMTS_DATA =[
    {
        name: "Abrove and Beyond!!!",
        type:"Standard"
    },
    {
        name: "Clone test",
        type:"Standard"
    },
    {
        name: "Good job!",
        type:"Peer to Peer"
    },
    {
        name: "Abrove and Beyond!!!",
        type:"Standard"
    },
    {
        name: "Clone test",
        type:"Standard"
    },
    {
        name: "Good job!",
        type:"Peer to Peer"
    },
    {
        name: "Abrove and Beyond!!!",
        type:"Standard"
    },
    {
        name: "Clone test",
        type:"Standard"
    },
    {
        name: "Good job!",
        type:"Peer to Peer"
    },
    
]

export const getUserColumns = (program, options = {}) => {
    const { searchInAll = false } = options;
    return [
    /*
    {
        Header: "Employee ID",
        accessor: "employee_number",
    },
     */
    {
        Header: "First Name",
        accessor: "first_name",
        minWidth: 130,
        width: 130,
        maxWidth: 150,
       // Cell: ({ row, value }) => { return <Link to={`/program/view/${row.original.id}`}>{value}</Link>}
    },
     {
        Header: "Last Name",
        accessor: "last_name",
        minWidth: 130,
        width: 130,
        maxWidth: 130,
    },
    {
        Header: "Email Address",
        accessor: "email",
        minWidth: 280,
        width: 280,
        maxWidth: 280,
    },
    {
        Header: "Status",
        tooltip: "Current account status of the participant",
        accessor: "status.status",
        minWidth: 70,
        width: 70,
        maxWidth: 70,
    },
    ...(searchInAll ? [
        {
            Header: "Programs",
        tooltip: "Other programs this participant belongs to",
            accessor: "programs",
            minWidth: 200,
            width: 200,
            maxWidth: 250,
            Cell: ({ row }) => {
                const programs = row.original.programs || [];
                const fullNames = programs.map(p => p.name).filter(Boolean).join(', ');
                const display = fullNames.length > 30 ? fullNames.slice(0, 30) + '…' : fullNames;
                return (
                    <div className="hover-item addresses" style={{ cursor: 'default' }} data-tip={fullNames || undefined}>
                        {display || '—'}
                    </div>
                );
            },
        },
    ] : []),
      ...(Boolean(program?.is_cocard_program)
        ? [
            {
                Header: "Merchants",
        tooltip: "Merchant locations associated with this participant",
                accessor: "addresses",
                minWidth: 150,
                width: 150,
                maxWidth: 150,
                Cell: ({ row }) => {
                const addresses = row.original.addresses || [];
                const fullNames = addresses.map(addr => addr.name).join(', ');
                const display =
                    fullNames.length > 15 ? fullNames.slice(0, 15) + '...' : fullNames;

                return (
                    <div
                    className="hover-item addresses"
                    style={{ cursor: 'pointer' }}
                    data-tip={fullNames || undefined}
                    >
                    {display || 'default'}
                    </div>
                );
                },
            },
            ]
        : Boolean(program?.use_award_levels)
        ? [
            {
                Header: "Award Level",
        tooltip: "Participant's assigned award level",
                accessor: "award_level",
                minWidth: 150,
                width: 150,
                maxWidth: 150,
                Cell: ({ row }) => row.original.award_level || 'default',
            },
            ]
        : []
    ),
    {
        Header: "Points",
        tooltip: "Current point balance available to redeem",
        accessor: "pointBalance",
        minWidth: 100,
        width: 100,
        maxWidth: 100,
        Cell: ({ row }) => Math.floor(row.original.pointBalance * program.factor_valuation)
    },
    {
        Header: "Redeemed",
        tooltip: "Total points this participant has redeemed",
        accessor: "redeemedBalance",
        minWidth: 100,
        width: 100,
        maxWidth: 100
    },
    {
        Header: "Peer Balance",
        tooltip: "Points available to give to other participants",
        accessor: "peerBalance",
        minWidth: 150,
        width: 150,
        maxWidth: 180
    },

    ...(program?.uses_units
    ? [
        {
          Header: "Unit",
        tooltip: "Unit or apartment number associated with this participant",
          accessor: "unitNumber",
          minWidth: 100,
          width: 100,
          maxWidth: 100,
          Cell: ({ row }) => row.original?.unitNumber?.name ?? null
        },
      ]
    : []),

    ...(program?.has_entrata_hierarchy
    ? [
        {
          Header: "Lease ID",
        tooltip: "Entrata lease identifier for this participant",
          accessor: "entrata_lease_id",
          minWidth: 100,
          width: 100,
          maxWidth: 100,
          Cell: ({ row }) => row.original?.entrata_lease_id ?? null
        },
        {
          Header: "Entrata Status",
        tooltip: "Participant's current status in Entrata",
          accessor: "entrata_customer_status",
          minWidth: 150,
          width: 150,
          maxWidth: 180,
          Cell: ({ row }) => row.original?.entrata_customer_status ?? null
        },
      ]
    : []),

    ];
}
// 👇 Define your columns for addresses
export const USER_ADDRESS_COLUMNS = [
  {
    Header: "External ID",
    accessor: "external_id",
  },
  {
    Header: "Name",
    accessor: "name",
    minWidth: 250,
    width: 250,
    maxWidth: 250,
    Cell: ({ value }) => {
      // Cut to 15 chars + tooltip
      return (
        <div className="w-100">
          {value}
        </div>
      );
    },
    // Add this for styling
    style: { width: "200px", maxWidth: "200px", whiteSpace: "nowrap" },
  },
//   {
//     Header: "Street Address",
//     accessor: "street_address_1",
//   },
//   {
//     Header: "Street Address 2",
//     accessor: "street_address_2",
//   },
  {
    Header: "City",
    accessor: "city",
  },
//   {
//     Header: "State",
//     accessor: "state_province",
//   },
  {
    Header: "Postal Code",
    accessor: "postal_code",
  },
//   {
//     Header: "Country",
//     accessor: "country",
//   }
];
export const USERS_DATA =[
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    },
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    },
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    },
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    },
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    },
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    },
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    },
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    },
    {
        name: "Bobrowski, Robert",
        email:"r.bobrowski@temp-neteos.pl"
    }
       
]

export const PARTICIPANT_GOALPLAN_COLUMNS = [
    {
        Header: "Name",
        accessor: "name",
    },
    {
        Header: "Type",
        accessor: "type",
    },
    {
        Header: "State",
        accessor: "state",
    },
    {
        Header: "Date Begin",
        accessor: "date_begin",
    },
    {
        Header: "Date End",
        accessor: "date_end",
    },
    {
        Header: "Target",
        accessor: "target",
    },
    {
        Header: "Progress",
        accessor: "progress",
    },
]

export const PARTICIPANT_GOALPLAN_DATA =[
    {
        name: "Goal 1",
        type:"Sales",
        state:'Active',
        date_begin: '12/31/2022',
        date_end: '12/31/2023',
        target: '200',
        Progress:'progress'
    },
    {
        name: "Goal 1",
        type:"Sales",
        state:'Active',
        date_begin: '12/31/2022',
        date_end: '12/31/2023',
        target: '200',
        Progress:'progress'

    },
    {
        name: "Goal 1",
        type:"Sales",
        state:'Active',
        date_begin: '12/31/2022',
        date_end: '12/31/2023',
        target: '200',
        Progress:'progress'

    },
    {
        name: "Goal 1",
        type:"Sales",
        state:'Active',
        date_begin: '12/31/2022',
        date_end: '12/31/2023',
        target: '200',
        Progress:'progress'

    },
    {
        name: "Goal 1",
        type:"Sales",
        state:'Active',
        date_begin: '12/31/2022',
        date_end: '12/31/2023',
        target: '200',
        Progress:'progress'

    },
    
];
const setIconPath = (icon) => {
    const path = process.env.REACT_APP_API_STORAGE_URL + "/" + icon;
    return path;
  }
export const REWARD_HISTORY_COLUMNS = [
    {
        Header: "Event",
        accessor: "name",
    },
    {
        Header: "Notes",
        accessor: "notes",
    },
    {
        Header: "Restrictions",
        accessor: "restrictions",
    },
    {
        Header: "Referrer",
        accessor: "referrer",
    },
    {
        Header: "Date",
        accessor: "journal_event_timestamp",
        Cell: ({ row, value }) => {
          return `${new Date(value).toLocaleDateString("en-US", {})}`;
        },
    },
    {
        Header: "Reference Document",
        accessor: "",
    },
    {
        Header: "Points",
        accessor: "amount",
    },
    {
      Header: "",
      accessor: "icon",
      // align: "center",
      Cell: ({ row, value }) => (
          !value ? '' : <img height={50} src={setIconPath(value)} alt="icons" />
      ),
    }
  ];
  export const PEER_RECLAIM_DATA =[
    { 
        'awarded': '2023-02-03 07:51:44', 
        'event_name': 'Testttt',
        'amount': 200, 
        'id': 100, 
        'journal_event_id': 17 
    },
    { 
        'awarded': '2023-02-03 07:51:44', 
        'event_name': 'Test',
        'amount': 200, 
        'id': 100, 
        'journal_event_id': 26 
    },
    { 
        'awarded': '2023-02-03 07:51:44', 
        'event_name': 'Test',
        'amount': 200, 
        'id': 100, 
        'journal_event_id': 39
    },
    { 
        'awarded': '2023-02-03 07:51:44', 
        'event_name': 'Test',
        'amount': 200, 
        'id': 100, 
        'journal_event_id': 49 
    }, 
];
export const USER_GOALS_COLUMNS =[
    {
        Header: "Name",
        accessor: "plan_name",
    },
    {
        Header: "Type",
        accessor: "goal_plan_type_name",
    },
    {
        Header: "Status",
        accessor: "goal_state_name",
    },
    {
        Header: "Date Begin",
        accessor: "date_begin",
        Cell: ({ row, value }) => {
            return `${new Date(value).toLocaleDateString("en-US", {})}`;
          },
    },
    {
        Header: "Date End",
        accessor: "date_end",
        Cell: ({ row, value }) => {
            return `${new Date(value).toLocaleDateString("en-US", {})}`;
        },
    },
    {
        Header: "Target",
        accessor: "target_value",  
        Cell: ({ row, value }) => {
            return `${toCurrency(value)}`;
        },
    },
    {
        Header: "Progress",
        accessor: "calc_progress_percentage",
        Cell: ({ row, value }) => {
            return  <>${showPercentage(value)} <span style={{ fontWeight:'bold'}}>{row.original.iterations? `(${row.original.iterations})` :''}</span></>;
        }
    },
];

export const PENDING_AWARD_COLUMNS = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Event Name",
    accessor: "event_name",
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Submitted By",
    accessor: "submitted_by",
  },
  {
    Header: "Date of Award Submission",
    accessor: "date_of_award_submission",
    Cell: ({ row, value }) => {
        return <span>{new Date(value).toLocaleDateString("en-US", {})}</span>;
    },
  },
];

export const BUDGET_PROGRAM_SUMMARY = [
  {
    Header: "Budget",
    accessor: "monthly_budget_amount",
    Cell: ({ row, value }) => {
      return `${toCurrency(value)}`;
    },
  },
  {
    Header: "Awaiting",
    accessor: "monthly_award_pending",
    Cell: ({ row, value }) => {
      return `${toCurrency(value)}`;
    },
  },
  {
    Header: "Remaining",
    accessor: "monthly_budget_amount_remaining",
    Cell: ({ row, value }) => {
      return `${toCurrency(value)}`;
    },
  },
  {
    Header: "Award Distributed",
    accessor: "monthly_awarded_distributed",
    Cell: ({ row, value }) => {
      return `${toCurrency(value)}`;
    },
  },

  {
    Header: "Budget",
    accessor: "yearly_budget_amount",
    Cell: ({ row, value }) => {
      return `${toCurrency(value)}`;
    },
  },
  {
    Header: "Awaiting",
    accessor: "yearly_award_pending",
    Cell: ({ row, value }) => {
      return `${toCurrency(value)}`;
    },
  },
  {
    Header: "Remaining",
    accessor: "yerly_budget_amount_remaining",
    Cell: ({ row, value }) => {
      return `${toCurrency(value)}`;
    },
  },
  {
    Header: "Award Distributed",
    accessor: "yearly_awarded_distributed",
    Cell: ({ row, value }) => {
      return `${toCurrency(value)}`;
    },
  },
];
